import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 64px - 50px);
  width: 100vw;
  background: #fff;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  text-align: center;
`;

export const Title = styled.div`
  font-size: 150px;
  color: #333;
  margin-bottom: 20px;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 100px;
  }
`;

export const Subtitle = styled.div`
  font-size: 30px;
  color: #555;
  margin-bottom: 15px;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const Description = styled.div`
  font-size: 20px;
  color: #999;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;
